export const APP_DEF_ID = '2608697e-067a-44e2-8250-8e390df5bf71';
export const DUPLEXER_ENDPOINT = 'duplexer.wix.com';
//# sourceMappingURL=app.js.map